/* esm.sh - fast-shallow-equal@1.0.0 */
export * from "/*fast-shallow-equal@1.0.0/esnext/fast-shallow-equal.mjs";
export { default } from "/*fast-shallow-equal@1.0.0/esnext/fast-shallow-equal.mjs";
